@if(loading) {
  <div class="bg-black/50 flex justify-center items-center fixed inset-0 z-40">
    <app-loader [message]="'Buscando'"></app-loader>
  </div>
}

<div class="px-6 w-full space-y-5 mt-3">
  <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5">
    <div class="space-y-3">
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1 block">Fechas</label>
        <app-datepicker (updateDates)="setDatesOnFilter($event)" [selectedFilterRange]="1"></app-datepicker>
      </div>
      <div class="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
        <div class="w-full sm:w-56">
          <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1 block">Tarjetas</label>
          <p-select [options]="cards" [(ngModel)]="selectedCard" optionLabel="text" optionValue="value"
            [filter]="cards.length > 10" filterPlaceholder="Buscar..." class="w-full" />
        </div>
        <button pButton label="Buscar" icon="pi pi-search" class="p-button-sm w-full sm:w-auto" (click)="getLogs()"></button>
      </div>
    </div>
  </div>

  @if(logs) {
    <app-custom-table [rowsByPage]="10" [headers]="headers" [elements]="logs"
      [actions]="[]" [hasButton]="false" [hasFilter]="true"></app-custom-table>
  }
</div>
